<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2 5.33333C2 6.06667 2.5 6.66667 3.11111 6.66667H20.8889C21.5 6.66667 22 6.06667 22 5.33333C22 4.6 21.5 4
      20.8889 4H3.11111C2.5 4 2 4.6 2 5.33333ZM10.1111 20H13.8889C14.5 20 15 19.4 15 18.6667C15 17.9333 14.5 17.3333
      13.8889 17.3333H10.1111C9.5 17.3333 9 17.9333 9 18.6667C9 19.4 9.5 20 10.1111 20ZM17.5556 13.3333H6.44444C5.83333
      13.3333 5.33333 12.7333 5.33333 12C5.33333 11.2667 5.83333 10.6667 6.44444 10.6667H17.5556C18.1667 10.6667 18.6667
      11.2667 18.6667 12C18.6667 12.7333 18.1667 13.3333 17.5556 13.3333Z"
      fill="currentColor"
    />
  </svg>
</template>
